<div class="turnos-wrapper" *ngIf="modo==='normal'">
  <div class="card glass turnos-card" *ngIf="!cargando; else elseBlock">
    <div class="card-header">
      <span class="mdi mdi-calendar-clock"></span>
      <h3>Seleccionar Fecha y Hora de Retiro/Envío</h3>
    </div>

    <div class="days-list" *ngIf="diasdisponibles.length > 0; else notTurnos">
      <div class="day-group" *ngFor="let turno of diasdisponibles">
        <h4 class="day-title">
          <span class="mdi mdi-calendar-blank"></span>
          {{turno.dia}}
        </h4>
        <div class="time-slots-grid">
          <ng-container *ngFor="let turnin of turno.turnos">
            <div *ngIf="turnin.activado" class="time-slot" [class.selected]="turnin.selecionado"
              (click)="onchange(turnin)">
              <span class="mdi" [class.mdi-check-circle]="turnin.selecionado"
                [class.mdi-clock-outline]="!turnin.selecionado"></span>
              <span class="time-text">{{turnin.dia}}</span>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <ng-template #elseBlock>
    <div *ngIf="!error; else notTurnos" class="card glass loading-card">
      <div class="loading-content">
        <spinner [height]="'50px'" [width]="'50px'"></spinner>
        <p>Recuperando turnos disponibles...</p>
      </div>
    </div>
  </ng-template>

  <ng-template #notTurnos>
    <div class="card glass error-card">
      <span class="mdi mdi-calendar-remove"></span>
      <p>No hay turnos disponibles en este momento.</p>
    </div>
  </ng-template>
</div>